import { gql } from "@apollo/client"

export const GET_SUGGESTED_GROUPS_USER = gql`
  query getSuggestedGroupsUser($userId: ID!, $first: Int, $skip: Int, $search: String) {
    suggestedGroupsUser(userId: $userId, first: $first, skip: $skip, search: $search) {
      id
      name
      isAdminGroup
      organization {
        id
        name
      }
      terminals {
        id
        serialNumber
        imageUrl
        nickname
      }
      roles {
        id
        name
        users {
          id
          firstName
          lastName
          email
          title
          profile {
            id
            imageUrl
          }
        }
      }
    }
  }
`
